import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";

/**
 * One labelled figure.
 *
 * The overline label is uppercase and small, the body is whatever the caller
 * puts in it — this is a frame, not a formatter. Meteoric drew the same tile
 * with its own surface and border tokens; here it is the portal `Card`, so a
 * Machine tile and a Profit Yield tile are the same object rather than two
 * things that merely resemble each other.
 */
export function StatTile({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Card className={className}>
      <CardContent className="flex flex-col gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</p>
        <div className="flex-1">{children}</div>
      </CardContent>
    </Card>
  );
}
